import { PAYMENT_TYPE } from "../helpers/Payment"
import { BankDetails, CreditCardDetails } from "../payment/Payment"

export const INVOICE = "invoice"
export const INVOICES = "invoices" as const

export enum REFUND_TYPE {
    REFUND = "refund",
    REFUND_ACCOUNT = "refund-account",
    NO_REFUND = "no-refund",
}

export enum VOID_TYPE {
    VOID_ONLY = "void",
    REFUND_AS_NEW_PAYMENT = "refund_as",
    REFUND_ON_ACCOUNT ="refund_on_account",
}

export const refundToVoidMap: Record<REFUND_TYPE, VOID_TYPE> = {
    [REFUND_TYPE.NO_REFUND]: VOID_TYPE.VOID_ONLY,
    [REFUND_TYPE.REFUND_ACCOUNT]: VOID_TYPE.REFUND_ON_ACCOUNT,
    [REFUND_TYPE.REFUND]: VOID_TYPE.REFUND_AS_NEW_PAYMENT,
}

export interface PaymentRefundForm {
    processsedTableForm: PaymentTableForm,
    pendingTableForm: PaymentTableForm,
    additionalMethodsForm: AdditionalMethodForm[],
    notes: string,
}

export interface PaymentTableForm {
    isAllChecked: boolean,
    rows: PaymentRowForm[],
}

export interface PaymentRowForm {
    id: string,
    paymentTransactionId: string,
    paymentId: string,
    identifier: string,
    refundableAmount: number,
    currency: string,
    creditCardDetails?: CreditCardDetails,
    bankAccountDetails?: BankDetails,
    paymentType: string,
    selected: boolean,
    refundAmount: number,
    refundMethod: string,
    approved: boolean,
    refundable: boolean,
    processing: boolean,
    integrationKey: string,
    creditMemoPaymentDetails?: PaymentRowForm,
}

export interface AdditionalMethodForm {
    id: string,
    refundAmount: number,
    currency: string,
    refundMethod: string,
}

export interface PaymentRefundPayload {
    returnId?: string;
    invoiceId?: string;
    creditMemoId?: string;
    amount: string;
    notes: string;
    currency: string;
    contactId: string;
    source: string;
    fingerprintId: string;
    selectedPayments: PaymentToRefund[];
    voidAction?: VOID_TYPE
}

export interface OnAccountRefundPayload {
    note: string;
    notes: string;
    amount: string;
    paymentType: PAYMENT_TYPE;
    currency: string;
    contactId: string;
    source: string;
    fingerprintId: string;
    transactions: OnAccountTransactionRefund[];
    voidAction?: VOID_TYPE
    locationId: string
}
export interface NoRefundPayload {
    invoiceId?: string;
    notes: string;
    currency: string;
    contactId: string;
    source: string;
    fingerprintId: string;
    voidAction: VOID_TYPE
}
export interface PaymentToRefund {
    paymentId: string;
    amountToRefund: string;
    refundMethod: string;
    customPaymentId?: string;
    isProcessedRefund?: boolean;
    paymentTransactionId?: string;
}

export interface OnAccountTransactionRefund {
    invoiceId: string;
    amount: string;
}

export const ORIGINAL_METHOD_PAYMENT_TYPE = "original-method"

export const displayablePaymentTypes = [
    PAYMENT_TYPE.CREDIT_CARD,
    PAYMENT_TYPE.BANK_TRANSFER,
    PAYMENT_TYPE.CHECK,
    PAYMENT_TYPE.CASH,
    PAYMENT_TYPE.CREDIT,
]


// WEBPACK FOOTER //
// ./src/state/invoice/Constants.ts